// let frontendAuth = true

import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'


Vue.use(VueRouter)

let routes = []
let defaultRoutes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
]

routes = routes.concat(
    defaultRoutes,
  
);

const router = new VueRouter({
  routes
})

// if(frontendAuth){
//   router.beforeEach((to, from, next) => {
//     if (!localStorage.getItem('id') && to.path !== '/login') next({ name: 'Login' })
//     else next()
//   })
// }


export default router
